<template>
  <div :class="$style.shared_wraper">
    <core-popup :show="isConfirmPopup">
      <template #body>
        <div :class="$style.shared_content">
          <div
            :class="$style.shared_logo"
            v-html="logo"
          />
          <div :class="[$style.shared_message, error ? $style.shared_message_error : '']">
            <span v-if="error">{{ locales('share_popup_message_error') }}</span>
            <span v-else>{{ locales('share_popup_message_info') }}</span>
          </div>
          <vgp-label-slot :label="locales('share_popup_password_title')">
            <template #body>
              <vgp-input
                ref="passwordInput"
                v-model="password"
                input-type="password"
                :is-error="error"
                :placeholder="locales('share_popup_enter_password_placeholder')"
                @onKeyup="onPasswordKeyup"
              />
              <vgp-button
                :class="$style.submit_button"
                type="brand-fill"
                width="100%"
                :label="locales('share_popup_password_submit_placeholder')"
                @onClick="submit"
              />
            </template>
          </vgp-label-slot>
          <div :class="$style.shared_help">
            {{ `${locales('share_popup_support_message')} ` }}
            <a :href="`mailto:${locales('share_popup_mailto')}`">{{ locales('share_popup_mailto') }}</a>
          </div>
        </div>
      </template>
    </core-popup>
    <portal-target name="popup" />
  </div>
</template>

<script>
import axios from 'axios';
import CorePopup from '$$vueCmp/popups/corePopup/corePopup.vue';
import VgpLabelSlot from '$$uiKitComp/vInput/vgpLabelSlot.vue';
import VgpInput from '$$uiKitComp/vInput/vgpInput.vue';
import VgpButton from '$$uiKitComp/globalButton/vgpButton.vue';
import logo from '../../svg/logo.svg';

export default {
  components: {
    VgpLabelSlot,
    CorePopup,
    VgpInput,
    VgpButton,
  },
  data() {
    return {
      locales: __,
      isConfirmPopup: true,
      password: '',
      error: false,
      logo,
    };
  },
  methods: {
    onPasswordKeyup(e) {
      if (e.key === 'Enter') {
        this.submit();
      }
    },
    submit() {
      axios.post(window.location.pathname, {
        password: this.password,
      }).then(() => {
        this.error = false;
        window.location.reload();
      }).catch(() => {
        this.error = true;
        this.$refs.passwordInput.focusInput();
      });
    },
  },

};
</script>

<style module src="./less/publicUrls.less"></style>
